<template>
  <div class="review-mood">
    <img class="mood-icon" v-if="mood == 'positive'" src="/static/img/mood--positive.svg">
    <img class="mood-icon" v-if="mood == 'negative'" src="/static/img/mood--negative.svg">
  </div>
</template>

<script>
  export default {
    name: 'review-mood',

    props: ['mood'],

    data: function () {
      return {

      }
    },

    mounted:function() {
    },

    beforeDestroy: function() {

    },

    methods: {

    },

    computed:{

    }
  }
</script>

<style lang="less" scoped>
  @import "../../../less/base/project/_colors";

  .review-mood {
    .mood-icon {
      width: 4rem;
    }
  }
</style>



// WEBPACK FOOTER //
// ReviewMood.vue?7fc7b1be